import React from "react";
import { Box, MenuItem, Typography } from "@mui/material";
import { ReactComponent as Ban } from "../../../assets/images/ChatImages/ban.svg";
import { ReactComponent as CloseChat } from "../../../assets/images/ChatImages/stopchat.svg";

/**
 * Figma overflow menu: Ban this visitor / End chat
 * node 13055:15972
 */
function ChatOverflowMenu({
  open,
  onBan,
  onEndChat,
  showEndChat = true,
  showBan = true,
}) {
  if (!open) return null;
  if (!showBan && !showEndChat) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        top: "100%",
        right: 0,
        mt: 0.5,
        width: 184,
        bgcolor: "#fff",
        border: "1px solid #D5DCE1",
        borderRadius: "8px",
        boxShadow: "0px 15px 20px 0px rgba(6,21,34,0.05)",
        zIndex: 20,
        py: 1,
        px: 1,
      }}
      role="menu"
    >
      {showBan && (
        <MenuItem
          onClick={onBan}
          sx={{
            borderRadius: "8px",
            gap: 1,
            px: 1,
            py: 0.75,
            minHeight: 32,
            color: "#405261",
            "&:hover": { bgcolor: "#F9FAFA" },
          }}
        >
          <Box sx={{ width: 16, height: 16, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <Ban />
          </Box>
          <Typography sx={{ fontSize: 14, color: "#405261", lineHeight: "normal" }}>
            Ban this visitor
          </Typography>
        </MenuItem>
      )}
      {showEndChat && (
        <MenuItem
          onClick={onEndChat}
          sx={{
            borderRadius: "8px",
            gap: 1,
            px: 1,
            py: 0.75,
            minHeight: 32,
            bgcolor: "#F9FAFA",
            color: "#FF4D4F",
            "&:hover": { bgcolor: "#FFF1F0" },
          }}
        >
          <Box sx={{ width: 16, height: 16, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <CloseChat />
          </Box>
          <Typography sx={{ fontSize: 14, color: "#FF4D4F", lineHeight: "normal" }}>
            End chat
          </Typography>
        </MenuItem>
      )}
    </Box>
  );
}

export default ChatOverflowMenu;
